export const personMocks = [
  {
    jobTitle: 'Human Optimization Consultant',
    firstName: 'Eliane',
    lastName: 'Gerhold',
    region: 'North America',
    department: 'Business Relationship Management',
    phoneNumber: '1-583-060-4104 x3312',
    headshot: {
      url:
        'https://images.ctfassets.net/03fbs7oah13w/27UkmtlzmyMvMEyqaTBLCP/905ac437842e85a0c21e6977803e8642/profile-default.png',
      description: 'Default profile image associated with a person'
    },
    email: 'xyz@fitchgroyp.com',
    profileSlug: '/analyst',
    analystTag: 'Tag 1',
    professional: 'Business Analyst'
  },
  {
    jobTitle: 'Corporate Group Technician',
    firstName: 'Carissa',
    lastName: 'Kutch',
    region: 'North America',
    department: 'Business Relationship Management',
    phoneNumber: '1-352-107-9094 x69819',
    headshot: {
      url:
        'https://images.ctfassets.net/03fbs7oah13w/27UkmtlzmyMvMEyqaTBLCP/905ac437842e85a0c21e6977803e8642/profile-default.png',
      description: 'Default profile image associated with a person'
    }
  },
  {
    jobTitle: 'Product Functionality Officer',
    firstName: 'Garfield',
    lastName: 'Predovic',
    region: 'North America',
    department: 'Investors',
    phoneNumber: '(192) 623-8411 x19832',
    headshot: {
      url:
        'https://images.ctfassets.net/03fbs7oah13w/27UkmtlzmyMvMEyqaTBLCP/905ac437842e85a0c21e6977803e8642/profile-default.png',
      description: 'Default profile image associated with a person'
    }
  },
  {
    jobTitle: 'Lead Markets Orchestrator',
    firstName: 'Tillman',
    lastName: "O'Kon",
    region: 'North America',
    department: 'Business Relationship Management',
    phoneNumber: '338.810.7238 x8088',
    headshot: {
      url:
        'https://images.ctfassets.net/03fbs7oah13w/27UkmtlzmyMvMEyqaTBLCP/905ac437842e85a0c21e6977803e8642/profile-default.png',
      description: 'Default profile image associated with a person'
    }
  },
  {
    jobTitle: 'Dynamic Accounts Analyst',
    firstName: 'Theodore',
    lastName: 'Gleason',
    region: 'North America',
    department: 'Investors',
    phoneNumber: '182.712.5508 x1364',
    headshot: {
      url:
        'https://images.ctfassets.net/03fbs7oah13w/27UkmtlzmyMvMEyqaTBLCP/905ac437842e85a0c21e6977803e8642/profile-default.png',
      description: 'Default profile image associated with a person'
    }
  },
  {
    jobTitle: 'Chief Marketing Representative',
    firstName: 'Rachelle',
    lastName: 'Graham',
    region: 'North America',
    department: 'Business Relationship Management',
    phoneNumber: '(557) 606-6420 x7091',
    headshot: {
      url:
        'https://images.ctfassets.net/03fbs7oah13w/27UkmtlzmyMvMEyqaTBLCP/905ac437842e85a0c21e6977803e8642/profile-default.png',
      description: 'Default profile image associated with a person'
    }
  }
]

export const reducedPersonMocks = personMocks.map(item => {
  const newItem = { ...item }
  delete newItem.phoneNumber
  delete newItem.region
  return newItem
})
